// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function FileList(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "FileList" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3V21H19V7L14 3H5ZM16 9.5H8V11H16V9.5ZM16 12.5H8V14H16V12.5ZM8 15.5H16V17H8V15.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=FileList.js.map